// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/lib/tag/style/index.less
// module id = 1164
// module chunks = 0